<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useI18n } from '#i18n'

const { locale } = useI18n()

onMounted(() => {
  console.log(
    '%cWant to work with us? %csend email to %cjob@bittrip.ai',
    'font-size: 20px; font-weight: bold; color: #3b82f6;',
    'font-size: 16px; color: #6b7280;',
    'font-size: 16px; font-weight: bold; color: #10b981; text-decoration: underline;'
  )
})

watch(locale, (newLocale) => {
  useHead({
    htmlAttrs: {
      dir: newLocale === 'fa' ? 'rtl' : 'ltr',
      lang: newLocale
    }
  })
}, { immediate: true })
</script>
